import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.25rem;
`;

const PriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const CurrencyWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

export default {
  Wrapper,
  PriceWrapper,
  CurrencyWrapper,
};
